const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'TICKET_ASSIGNEES_SUCCESS') {
        return {
            ...state,
            [action.requestParams.params.issueId]: action.payload,
        };
    }

    return state;
}

export default reducer;
